export function Http403Handler() {
  if (process.env.NODE_ENV === "development") {
    console.error("Доступ запрещен!");
  }
}
